export default {
  namespaced: true,
  state: {
    collectionsModal: {
      show: false,
      customer_uuid: null,
      source: null,
      handler: null,
      title: null
    },
  },
  getters: {},
  actions: {
    showCollectionsModal({commit}, payload) {
      commit('showCollectionsModal', payload);
    },
    hideCollectionsModal({commit}) {
      commit('hideCollectionsModal');
    },
  },
  mutations: {
    showCollectionsModal(state, {customer_uuid, source, handler, title}) {
      state.collectionsModal.show = true
      state.collectionsModal.customer_uuid = customer_uuid
      state.collectionsModal.source = source
      state.collectionsModal.handler = handler
      state.collectionsModal.title = title
    },
    hideCollectionsModal(state) {
      state.collectionsModal.show = false
      state.collectionsModal.customer_uuid = null
      state.collectionsModal.source = null
      state.collectionsModal.handler = null
      state.collectionsModal.title = null
    },
  },
  modules: {}
}
